<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix" style="margin-bottom: 134px;">
      <!--左侧导航 start-->
      <user-nav :userNav="userNav"></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
      <div class="user-main-right">
        <h2 class="user-order-title">我的订单</h2>
        <ul class="user-order-list">
          <li class="user-order-list-item" v-for="(item,index) in List" :key="index">
            <div class="user-order-list-item-top">
              <p class="time"><span>下单时间：{{item.create_time*1000 | formatDate}}</span><span>订单编号：{{item.order_num}}</span></p>
              <span class="complet status cancel">已完成</span>
            </div>
            <div class="user-order-list-item-bot">
              <div class="title">
                <i class="order-list-img"><img :src="item.course_info.course_pic" :onerror="errorImg01" alt=""></i>
                <div class="order-list-txt">
                  <h3 class="order-list-title">{{item.course_info.course_name}}</h3>
                  <p class="order-list-type video-txt-color" style="color: #48b5fa" v-if="item.course_info.course_type==0">线上课</p>
                  <p class="order-list-type video-txt-color" style="color: #48b5fa" v-if="item.course_info.course_type==1">直播课</p>
                  <p class="order-list-teacher">作者：<span>{{item.course_info.teacher_name}}</span></p>
                </div>
              </div>
              <div class="info">
                <p v-if="item.course_info.course_type==0">
   <span>共约
                    <span v-show="item.course_info.total_video_time/60 >=60">{{ parseInt(item.course_info.total_video_time/360)}}小时</span>
                    <span v-if="item.course_info.total_video_time>=60&&item.course_info.total_video_time/60 >=60&&parseInt(item.course_info.total_video_time/60%60)!=0">{{parseInt(item.course_info.total_video_time/60%60)}}分钟</span>
                    <span v-if="item.course_info.total_video_time/60<60&&parseInt(item.course_info.total_video_time/60)!=0">{{parseInt(item.course_info.total_video_time/60)}}分钟</span>
                    <span v-show="item.course_info.total_video_time%60!=0">{{parseInt(item.course_info.total_video_time%60)}}秒</span>
                  </span>                  <span v-show="item.course_info.total_video_time==null">0小时</span>
                </p>                <p v-if="item.course_info.course_type==1">{{item.course_info.live_start_time}}至{{item.course_info.live_end_time}}</p>
              </div>

              <div class="price">
                <p class="order-list-price">实付金额：<span>{{item.price}}</span>元</p>
              </div>
              <div class="btn" @click="orderDetailFun(item.id)">
                <p>订单详情</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import UserNav from '.././components/user-nav.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/js/tool.js'
  export default {
    name: "user-c-order",
    components:{
      UserNav,
      navCom,
      footerCom
    },
    data(){
      return{
        errorImg01:'this.src="' + require('../../../static/images/zmr-images/default.jpg') + '"',
        navActive:3,
        userNav:9,
        List:[],//订单列表
        noDataFlag:0,//无数据标识 0:有数据 1无数据
      }
    },
    //下单时间  时间戳转换成日期
    filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      },
    },
    methods: {
      orderDetailFun (id) {
        this.$router.push({
          path: `/order-payment-detail`,
          query: {
            order_id: id,
          },
        });
      },
      waitOrder(){
        let data={
          user_id:this.$store.state.uuid
        };
        tool.postData('Center_Order/completeOrder',data,(res)=>{
          this.List=res.data.data;
        })
      }
    },
    computed: {
      userOrderNav(){
        return this.$store.state.userOrderNav;
      },
    },
    mounted(){
      this.waitOrder()
    }
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin:0 auto ;
  }
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .all-whole{
    background: #fbfbfb;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    height: 720px;
    background: #ffffff;
  }
  .user-order-list-item-top .status.complet{
    color: #1a71ff;
  }
  .user-order-title{
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    font-size: 18px;
    color: #252525;
    padding-left: 20px;
    font-weight: 500;
    margin-bottom: 23px;
  }
  .user-order-nav{
    margin-bottom: 20px;
  }
  .user-order-nav a{
    line-height: 45px;
    color: #a0a0a0;
    font-size: 14px;
    margin-right: 46px;
    padding-bottom: 6px;;
  }
  .user-order-nav a.active{
    color: #1a71ff;
    border-bottom: 2px solid #1a71ff;
  }
  .user-order-nav a:first-child{
    margin-left:20px;
  }
  .user-order-list-item-top{
    height: 47px;
    background: #f3f3f3;
    border-bottom: 1px solid #e3e3e3;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }

  .user-order-list-item{
    border: 1px solid #e3e3e3;
    width: 954px;
    height: 180px;
    margin: 0 auto 26px;
  }
  .user-order-list-item-top .time{
    line-height: 47px;
    color: #717171;
    font-size: 14px;
  }
  .user-order-list-item-top .time span{
    margin-right: 50px;
  }
  .user-order-list-item-top .status{
    line-height: 47px;
    font-size: 16px;
  }
  .user-order-list-item-bot{
    font-size: 0;
    height: 135px;
    display: flex;
    align-items: center;
  }
  .user-order-list-item-bot .title{
    width: 425px;
    height: 133px;
    vertical-align: top;
    padding: 0 10px;
    box-sizing: border-box;
    display: inline-block;
  }
  .order-list-img{
    width: 100px;
    height: 100px;
    display: inline-block;
    margin-top: 15px;
  }
  .order-list-img img{
    width: 100%;
    height: 100%;
    display: block;
  }
  .order-list-txt{
    display: inline-block;
    vertical-align: top;
    margin-top: 19px;
    margin-left: 15px;
  }
  .order-list-title{
    display: inline-block;
    font-size: 16px;
    color: #414141;
    font-weight: 600;
    line-height: 36px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 200px;
  }
  .order-list-type{
    font-size: 14px;
    line-height: 30px;
  }
  .order-list-teacher{
    font-size: 14px;
    color: #8c8c8c;
    line-height: 40px;
  }

  .user-order-list-item-bot .info{
    width: 250px;
    display: inline-block;
    line-height: 135px;
    height: 100%;
    overflow: auto;
  }
  .user-order-list-item-bot .info p{
    font-size: 14px;
    color: #4c4c4c;
    display: inline-block;
    vertical-align: middle;
    line-height: 30px;
    overflow: auto;
  }
  .user-order-list-item-bot .price{
    width: 212px;
    vertical-align: top;
    line-height: 135px;
    text-align: center;
    display: inline-block;
  }
  .order-list-price{
    font-size: 16px;
    color: #4c4c4c;
  }
  .order-list-price span{
    color: #ed0101
  }
  .user-order-list-item-bot .btn{
    display: inline-block;
  }
  .user-order-list-item-bot .btn p{
    width: 103px;
    height: 32px;
    border: 1px solid #2ea6a5;
    font-size: 16px;
    line-height: 32px;
    text-align: center;
    color: #2ea6a5;
    cursor: pointer;
    margin-right: 11px;
  }

  /* 课程类型文字 */
  .video-txt-color{
    color: #ff0000
  }
  /* 订单状态文字 */
  .user-order-list-item-top .status.complet{
    color: #1a71ff;
  }
  .user-order-list{
    height: 600px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/user-c-order.vue